import * as Yup from 'yup';

import { globalMessages, isEmail } from '@savgroup-front-common/core/helpers';

const EmailOrderReferenceSchema = Yup.object().shape({
  orderReference: Yup.string().required(globalMessages.form.required),
  email: Yup.string()
    .required(globalMessages.form.required)
    .test('is-email', globalMessages.form.invalidEmail, (value) => {
      return isEmail(value);
    }),
});

export default EmailOrderReferenceSchema;
